import { Portal as ContextMenuPortal, Root as ContextMenuRoot } from "@radix-ui/react-context-menu";

import { ContextMenuContent } from "./ContextMenuContent";
import { ContextMenuTrigger } from "./ContextMenuTrigger";
import type { ContextMenuProps } from "./types";

export const ContextMenu = <TData,>({
  contextMenuItems,
  data,
  children,
  isDisabled,
  usePortal = true,
  className,
  modal = false,
  shouldOpenContextMenuByLeftClick = false,
  preventAutoFocusOnClose = false,
}: ContextMenuProps<TData>) => {
  if (usePortal) {
    return (
      <ContextMenuRoot modal={modal}>
        <ContextMenuTrigger
          shouldOpenContextMenuByLeftClick={shouldOpenContextMenuByLeftClick}
          isDisabled={isDisabled}
          className={className}
        >
          {children}
        </ContextMenuTrigger>
        <ContextMenuPortal>
          <ContextMenuContent
            contextMenuItems={contextMenuItems}
            data={data}
            preventAutoFocusOnClose={preventAutoFocusOnClose}
          />
        </ContextMenuPortal>
      </ContextMenuRoot>
    );
  }

  return (
    <ContextMenuRoot modal={modal}>
      <ContextMenuTrigger
        shouldOpenContextMenuByLeftClick={shouldOpenContextMenuByLeftClick}
        isDisabled={isDisabled}
        className={className}
      >
        {children}
      </ContextMenuTrigger>
      <ContextMenuContent
        contextMenuItems={contextMenuItems}
        data={data}
        preventAutoFocusOnClose={preventAutoFocusOnClose}
      />
    </ContextMenuRoot>
  );
};

export { ContextMenuVariant } from "./types";
export type { ContextMenuItems, ContextMenuProps } from "./types";
